import React from 'react';
import { CalendarDayTooltip, Typography, TypographyVariant } from '@secretescapes/falcon';
import { i18n } from '@secretescapes/i18n';
import { useTranslations } from '@utils/useTranslations';
import { DayData, NullableMoment } from '../Calendar.interfaces';
import { CalendarDayContent } from '../CalendarDayContent';
import { CalendarDayBackgroundWrapper, TooltipWrapper } from './CalendarDay.styles';

interface Props {
  data: DayData;
  startDate: NullableMoment;
  endDate: NullableMoment;
  daySize?: number;
  isLoading: boolean;
  isMobile: boolean;
}

export const CalendarDay = ({ data, startDate, endDate, daySize, isLoading, isMobile }: Props) => {
  const { day, formattedDay, isFirstCheckOut, isUnavailableCheckOut, price } = data;

  const { translations } = useTranslations();

  return (
    <CalendarDayBackgroundWrapper>
      {isFirstCheckOut || isUnavailableCheckOut ? (
        <CalendarDayTooltip
          delay={!isMobile && isFirstCheckOut && endDate?.isAfter(startDate, 'month') ? 300 : 0}
          isOpenByDefault={!isUnavailableCheckOut}
          day={day}
          isMobile={isMobile}
          isDesktopStyle={true}
          isResponsive={!isMobile}
          daySize={isMobile ? daySize : undefined}
          content={
            <TooltipWrapper>
              <Typography variant={TypographyVariant.micro} color="inherit">
                {i18n(
                  isFirstCheckOut
                    ? 'calendar.tooltip.firstAvailableCheckout'
                    : 'calendar.tooltip.unavailableCheckout',
                  [],
                  translations
                )}
              </Typography>
            </TooltipWrapper>
          }
        >
          <CalendarDayContent
            day={day}
            formattedDay={formattedDay}
            price={price}
            isStrikethrough={isUnavailableCheckOut}
            isLoading={isLoading}
          />
        </CalendarDayTooltip>
      ) : (
        <CalendarDayContent
          day={day}
          formattedDay={formattedDay}
          price={price}
          isStrikethrough={isUnavailableCheckOut}
          isLoading={isLoading}
        />
      )}
    </CalendarDayBackgroundWrapper>
  );
};
